import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Translation from '../../../../components/stateless/Translation';
import styles from './styles.scss';

const propTypes = {
  className: PropTypes.string,
  submitLabel: ({ children, submitLabel: label }) => {
    if (!children && !label) {
      return new Error('SMFormSubmitButton requires either `submitLabel` or `children`.');
    }
    if (label && (typeof label.defaultMessage !== 'string' || typeof label.id !== 'string')) {
      return new Error('`submitLabel` must have `id` and `defaultMessage` strings.');
    }
    return null;
  },
  submitting: PropTypes.bool,
  submittingLabel: PropTypes.shape({
    defaultMessage: PropTypes.string.isRequired,
    id: PropTypes.string,
  }),
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

const defaultProps = {
  className: undefined,
  submitLabel: undefined,
  submitting: undefined,
  submittingLabel: {
    defaultMessage: 'Submitting...',
  },
  disabled: false,
  children: undefined,
};

const SMFormSubmitButton = ({
  className,
  submitLabel,
  submitting,
  submittingLabel,
  disabled,
  children,
  ...rest
}) => {
  const classes = cx(
    styles.button,
    className,
  );

  return (
    <button
      {...rest}
      type="submit"
      disabled={disabled || submitting}
      className={classes}
    >
      {!children && <Translation {...(submitting ? submittingLabel : submitLabel)} />}
      {children}
    </button>
  );
};

SMFormSubmitButton.propTypes = propTypes;
SMFormSubmitButton.defaultProps = defaultProps;

export default SMFormSubmitButton;
